import { render, staticRenderFns } from "./white.vue?vue&type=template&id=5cb50882&scoped=true"
import script from "./white.vue?vue&type=script&lang=js"
export * from "./white.vue?vue&type=script&lang=js"
import style0 from "./white.vue?vue&type=style&index=0&id=5cb50882&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb50882",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cb50882')) {
      api.createRecord('5cb50882', component.options)
    } else {
      api.reload('5cb50882', component.options)
    }
    module.hot.accept("./white.vue?vue&type=template&id=5cb50882&scoped=true", function () {
      api.rerender('5cb50882', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/attendance/setting/white.vue"
export default component.exports